import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CloudHostingComponent } from './cloud-hosting/cloud-hosting.component';
import { CloudBackupComponent } from './cloud-backup/cloud-backup.component';
import { CloudComponent } from './cloud/cloud.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [CloudHostingComponent, CloudBackupComponent, CloudComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class CloudModule { }
